import React from 'react';

import PageSection from '../PageSections/PageSection';
import ContentfulImage from './ContentfulImage';
import * as styles from './ImageBleedCallout.module.scss';
import RichTextConverter from './RichText/RichTextConverter';

export default function ImageBleedCallout({ section }) {
  return (
    <PageSection
      slim
      className={styles.imageBleedCallout}
      innerClassName={styles.container}
      backgroundImage={section.backgroundImage}
      data-analytics-component={'image-bleed-callout'}
      data-analytics-id={section.title}
    >
      <div className={styles.content}>
        {section.title && <h2>{section.title}</h2>}
        {section.sectionContent && <RichTextConverter copy={section.sectionContent} />}
      </div>
      <ContentfulImage imageFragment={section.mainImage} className={styles.image} lazy={true} />
    </PageSection>
  );
}
